// extracted by mini-css-extract-plugin
module.exports = {"installationOptionImgWrapper":"InstallationTypeSelection_installationOptionImgWrapper__GRE3X"};